import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * YouthRoute — protected route for the Direction Jeunesse sub-space.
 *
 * Frontend gate is purely advisory; the canonical check lives on the
 * backend (every /api/youth/* endpoint runs through _require_youth and
 * audit-logs the call). This component just keeps non-eligible users
 * from landing on the page in the first place to avoid a noisy 403.
 *
 * Allows:
 *   - role in {admin, dg, resp_jeunesse}
 *   - users with youthRoleAccess === true
 */
const YouthRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#272727]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#9398DE]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const role = (user.role || '').toLowerCase();
  const hasAccess = role === 'admin' || role === 'dg' || role === 'resp_jeunesse' || !!user.youthRoleAccess;
  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default YouthRoute;
